// @flow

import keyMirror from 'keymirror';

const PayloadSources = keyMirror({
  SERVER_ACTION: null,
  VIEW_ACTION: null
});

export default PayloadSources;



// WEBPACK FOOTER //
// ./sdk/scripts/flux/PayloadSources.js